/** Controlled value for {@link GeocodedAddressFields} and patient-facing address forms. */
export type GeocodedAddressValue = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country?: string;
  /** Google Places ID when the patient picked a verified suggestion; null for manual entry. */
  placeId: string | null;
};

export const EMPTY_GEOCODED_ADDRESS: GeocodedAddressValue = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "USA",
  placeId: null,
};

export type GeocodedAddressFieldErrors = Partial<Record<keyof GeocodedAddressValue, string>>;
